import { logError } from 'client/javascript/util/logger';
import { COUNTRY_CODE_REG_EXP, HIDDEN_CLASS } from 'client/javascript/pages/product_details/constants';

export const renderNecessaryModulesBasedOnUserGeolocation = config => {
  try {
    const { countryCode, selector, locationAttributeName = 'conditionsToShow', searchBlock = document } = config;
    const DEFAULT_MODULE_TYPE = 'default';
    const OPTIONAL_MODULE_TYPE = 'optional';

    const module = {
      [DEFAULT_MODULE_TYPE]: null,
      [OPTIONAL_MODULE_TYPE]: null
    };
    const listOfCountryCode = [];
    const moduleNodes = searchBlock.querySelectorAll(selector);

    if (!moduleNodes.length) {
      return false;
    }

    moduleNodes.forEach(node => {
      const conditionsToShow = node.dataset[locationAttributeName];
      const isConditionExist = conditionsToShow && Boolean(conditionsToShow.trim().length);

      module[isConditionExist ? OPTIONAL_MODULE_TYPE : DEFAULT_MODULE_TYPE] = node;

      if (isConditionExist) {
        JSON.parse(conditionsToShow).forEach(condition => {
          condition.replace(COUNTRY_CODE_REG_EXP, (match, code) => {
            listOfCountryCode.push(code || match);
          });
        });
      }
    });

    if (listOfCountryCode.includes(countryCode)) {
      module.optional.classList.remove(HIDDEN_CLASS);
      module.default.remove();
    } else {
      module.default.classList.remove(HIDDEN_CLASS);

      if (module.optional) {
        module.optional.remove();
      }
    }
  } catch (error) {
    logError(`[Shared modules] renderNecessaryModulesBasedOnUserGeolocation failed: ${error.message}`, error);
  }
};
